// -----------------------------
// Local-only adjustments for cats (relative to dog DB prices).
// Positive = add to dog price; Negative = subtract.
// Tweak anytime without touching the DB.
// -----------------------------
var CAT_ADJUSTMENTS = {
  package: {
    // Per-size tuning; if a size is missing, we fall back to "default"
    small:    { nail: 5,  bath: 5,    touchup: 10,  grooming: 30 },
    medium:   { nail: 5,  bath: 0,    touchup: 0,   grooming: 15 },
    large:    { nail: 5,  bath: -15,  touchup: -15, grooming: -5 },
    'x-large':{ nail: 5,  bath: -30,  touchup: -35, grooming: -25 },
    default:  { nail: 0,   bath: 0,  touchup: 0,   grooming: 15 }
  },
  addons: {
    // Keys must match your add-on keys inside DB "additionalServices"
    nails: 0,
    sanitary: 5,
    deshed: 10
  },
  hairStyles: {
    // Style keys should match UI selections (see map below if DB differs)
    teddy: 25,
    breed_standard: 10,
    lion: 5 // UI uses "lion"; if DB uses "lion_cut" we map it below
  },
  conditions: {
    // NEW: Sensitive Skin (Hypoallergenic) surcharge
    sensitiveSkin: 10
  }
};

// Optional alias maps to avoid silent key mismatches between UI and DB
var ADDON_KEY_MAP = {
  // UI key : DB key
  deshedding: 'deshed'
};

var HAIRSTYLE_KEY_MAP = {
  // UI key : DB key
  lion: 'lion_cut' // if your DB uses 'lion_cut', we'll check both anyway
};

// -----------------------------
// Calculator
// -----------------------------
export const GroomingBookingCalculator = (bookingData, serviceDetails) => {
  var groomingPrices = {};
  if (serviceDetails && serviceDetails.grooming && serviceDetails.grooming.length > 0) {
    if (serviceDetails.grooming[0].additionalPrices) {
      groomingPrices = serviceDetails.grooming[0].additionalPrices;
    }
  }

  var originalTotal = 0;
  var total = 0;

  // Determine species
  var species = 'Dog';
  if (bookingData && bookingData.selectedPets && bookingData.selectedPets.length > 0) {
    var sp = bookingData.selectedPets[0];
    if (sp && sp.petType) species = sp.petType;
  }
  var isCat = species === 'Cat';

  // Use local component-level adjustments only
  var catAdj = isCat ? CAT_ADJUSTMENTS : null;

  // Validate grooming options
  var hasOptions =
    bookingData &&
    bookingData.groomingOptions &&
    bookingData.groomingOptions.selectedSize &&
    bookingData.groomingOptions.selectedPackage;

  if (hasOptions) {
    var selectedSize = bookingData.groomingOptions.selectedSize;       // 'small','medium','large','x-large'
    var selectedPackage = bookingData.groomingOptions.selectedPackage; // 'nail','bath','touchup','grooming','teeth'

    // Safety: cats should not be charged for 'teeth' if UI somehow sends it
    if (isCat && selectedPackage === 'teeth') {
      selectedPackage = 'bath';
    }

    // Base dog price (source of truth from DB)
    var base = 0;
    if (groomingPrices[selectedSize] && groomingPrices[selectedSize][selectedPackage]) {
      base = groomingPrices[selectedSize][selectedPackage];
    }

    // Apply cat package adjustments from local object
    if (isCat && catAdj && catAdj.package) {
      var packageAdj = 0;
      if (catAdj.package[selectedSize] && typeof catAdj.package[selectedSize][selectedPackage] === 'number') {
        packageAdj = catAdj.package[selectedSize][selectedPackage];
      } else if (catAdj.package.default && typeof catAdj.package.default[selectedPackage] === 'number') {
        packageAdj = catAdj.package.default[selectedPackage];
      }
      base = base + packageAdj;
      if (base < 0) base = 0; // guard
    }

    total = total + base;
    originalTotal = originalTotal + base;

    // Add-on services inside grooming options
    var addOnCatalog = null;
    if (groomingPrices[selectedSize] && groomingPrices[selectedSize].additionalServices) {
      addOnCatalog = groomingPrices[selectedSize].additionalServices;
    }

    if (bookingData.groomingOptions.additionalServices && addOnCatalog) {
      var addServices = bookingData.groomingOptions.additionalServices;

      // Array form: ['nails','sanitary','deshedding']
      if (Array.isArray(addServices)) {
        var i = 0;
        while (i < addServices.length) {
          var key = addServices[i];
          var lookup = null;

          if (addOnCatalog[key]) {
            lookup = key;
          } else if (ADDON_KEY_MAP[key] && addOnCatalog[ADDON_KEY_MAP[key]]) {
            lookup = ADDON_KEY_MAP[key];
          }

          if (lookup) {
            var addOnPrice = addOnCatalog[lookup];

            // Cat add-on adjustment (local)
            if (isCat && catAdj && catAdj.addons && typeof catAdj.addons[lookup] === 'number') {
              addOnPrice = addOnPrice + catAdj.addons[lookup];
              if (addOnPrice < 0) addOnPrice = 0;
            }

            total = total + addOnPrice;
            originalTotal = originalTotal + addOnPrice;
          }
          i = i + 1;
        }
      }
      // Object form: { nails: true, sanitary: false, deshedding: true }
      else if (typeof addServices === 'object') {
        for (var k in addServices) {
          if (Object.prototype.hasOwnProperty.call(addServices, k)) {
            if (addServices[k]) {
              var lookup2 = null;

              if (addOnCatalog[k]) {
                lookup2 = k;
              } else if (ADDON_KEY_MAP[k] && addOnCatalog[ADDON_KEY_MAP[k]]) {
                lookup2 = ADDON_KEY_MAP[k];
              }

              if (lookup2) {
                var addOnPrice2 = addOnCatalog[lookup2];

                // Cat add-on adjustment (local)
                if (isCat && catAdj && catAdj.addons && typeof catAdj.addons[lookup2] === 'number') {
                  addOnPrice2 = addOnPrice2 + catAdj.addons[lookup2];
                  if (addOnPrice2 < 0) addOnPrice2 = 0;
                }

                total = total + addOnPrice2;
                originalTotal = originalTotal + addOnPrice2;
              }
            }
          }
        }
      }
    }

    // Haircut style price (optional)
    if (bookingData.groomingOptions.selectedHaircutStyle) {
      var styleKey = bookingData.groomingOptions.selectedHaircutStyle; // e.g., 'summer','lion','teddy'
      var styleLookup = styleKey;

      // Try DB alias if direct key missing
      if (
        groomingPrices.hairStylePrices &&
        typeof groomingPrices.hairStylePrices[styleLookup] !== 'number' &&
        HAIRSTYLE_KEY_MAP[styleKey] &&
        typeof groomingPrices.hairStylePrices[HAIRSTYLE_KEY_MAP[styleKey]] === 'number'
      ) {
        styleLookup = HAIRSTYLE_KEY_MAP[styleKey];
      }

      var stylePrice = 0;
      if (groomingPrices.hairStylePrices && typeof groomingPrices.hairStylePrices[styleLookup] === 'number') {
        stylePrice = groomingPrices.hairStylePrices[styleLookup];
      }

      // Cat style adjustment (local) — check both UI key and mapped key
      if (isCat && catAdj && catAdj.hairStyles) {
        if (typeof catAdj.hairStyles[styleKey] === 'number') {
          stylePrice = stylePrice + catAdj.hairStyles[styleKey];
        } else if (typeof catAdj.hairStyles[styleLookup] === 'number') {
          stylePrice = stylePrice + catAdj.hairStyles[styleLookup];
        }
        if (stylePrice < 0) stylePrice = 0;
      }

      if (stylePrice > 0) {
        total = total + stylePrice;
        originalTotal = originalTotal + stylePrice;
      }
    }

    // Special conditions
    if (bookingData.groomingOptions.mattedHair) {
      total = total + 20;
      originalTotal = originalTotal + 20;
    }
    if (bookingData.groomingOptions.skunkTreatment) {
      total = total + 50;
      originalTotal = originalTotal + 50;
    }

    // NEW: Sensitive Skin (Hypoallergenic)
    if (bookingData.groomingOptions.sensitiveSkin) {
      var sensAdj = 0;
      if (isCat && catAdj && catAdj.conditions && typeof catAdj.conditions.sensitiveSkin === 'number') {
        sensAdj = catAdj.conditions.sensitiveSkin;
      }
      total = total + sensAdj;
      originalTotal = originalTotal + sensAdj;
    }
  }

  // Global add-on (e.g., leash walk)
  if (bookingData.additionalServices && bookingData.additionalServices.walk) {
    total = total + 20;
    originalTotal = originalTotal + 20;
  }

  return { originalPrice: originalTotal, discountedPrice: total };
};

export default GroomingBookingCalculator;
